"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_modal_1 = __importDefault(require("react-modal"));
const react_1 = require("react");
const AircraftEdit_1 = __importDefault(require("./AircraftEdit"));
const AircraftList_1 = __importDefault(require("./AircraftList"));
const dictionaries_1 = require("../../services/dictionaries");
const AircraftModal = ({ modalVisible, setModalVisible, userIsPilot, aircraft }) => {
    const [data, setData] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        setData(aircraft);
        setShowList(true);
    }, [aircraft]);
    const [showList, setShowList] = (0, react_1.useState)(false);
    const [editedAircraft, setEditedAircraft] = (0, react_1.useState)(dictionaries_1.initialAircraft);
    return ((0, jsx_runtime_1.jsx)(react_modal_1.default, { isOpen: modalVisible, onRequestClose: () => {
            setModalVisible(false);
            setData([]);
        }, contentLabel: "Pilot details", className: "modal-body aircraft-modal", overlayClassName: "modal-overlay", appElement: document.getElementById("app-root"), children: showList ?
            (0, jsx_runtime_1.jsx)(AircraftList_1.default, { setEditedAircraft: setEditedAircraft, data: data, setData: setData, setShowList: setShowList, userIsPilot: userIsPilot, setModalVisible: setModalVisible })
            :
                (0, jsx_runtime_1.jsx)(AircraftEdit_1.default, { editedAircraft: editedAircraft, setEditedAircraft: setEditedAircraft, data: data, setData: setData, setShowList: setShowList, userIsPilot: userIsPilot }) }));
};
exports.default = AircraftModal;
